import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { isPlatformBrowser } from "@angular/common";
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { PLATFORM_ID, Inject } from "@angular/core";
import { environment } from "src/environments/environment";

declare var google;
declare var gtag;
declare var fbq;

@Component({
  selector: 'app-salesproperties',
  templateUrl: './salesproperties.component.html',
  styleUrls: ['./salesproperties.component.css']
})
export class SalespropertiesComponent implements OnInit {

  notEmptyPost = true;
  notscrolly = true;
  soldProperties:any=[];
  public alwarBounds: any;
  public options: any;
  searchCategory:string = "all";
  listingLoader: boolean = false;
  

  constructor(@Inject(PLATFORM_ID) private platformId: Object,public service : AppService , public fb : FormBuilder, private spinner: NgxSpinnerService, private router: Router, private route: ActivatedRoute) { }

  scrollDistance = 2;
  throttle = 300;
  offset: any = 0;  
  limit: any = 12;
  lookingType:string;

  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completessalesproperties", "salesproperties", "SalesProperties");

    fbq('track', "CompleteSalesProperties" , {
      content_type: "salesproperties",
      content_title: this.router.url,
    });
  }

    this.lookingType = this.route.snapshot.paramMap.get('type');
    this.propertySearch.patchValue({"looking_type":this.lookingType});
    this.router.events.subscribe((ev) => { 

      if (ev instanceof NavigationEnd) {  
         
        this.lookingType = this.route.snapshot.paramMap.get('type');

        if(this.lookingType=='all'){

          this.propertySearch.patchValue({'looking_type':'0'});
    
        }else if(this.lookingType=='residential'){
    
          this.propertySearch.patchValue({'looking_type':'1'});
    
        }else if(this.lookingType=='commercial'){
    
          this.propertySearch.patchValue({'looking_type':'2'});
    
        }else if(this.lookingType=='agriculture'){
    
          this.propertySearch.patchValue({'looking_type':'3'});
    
        }else if(this.lookingType=='industrial'){
    
          this.propertySearch.patchValue({'looking_type':'4'});
    
        }else{
    
          this.router.navigateByUrl('404'); 
    
        }

        this.propertySearch.patchValue({"looking_type":this.lookingType});
        
        if(this.propertySearch.value.location){
          localStorage.setItem("location",this.propertySearch.value.location);
          localStorage.setItem("locationLat",this.propertySearch.value.location_lat);
          localStorage.setItem("locationLong",this.propertySearch.value.location_long);
        }
      }

    });

    var homeSearch= JSON.parse(localStorage.getItem("homesearch"));

      if(homeSearch){

        this.propertySearch.patchValue({
          "location":homeSearch.location,
          "location_lat":homeSearch.location_lat,
          "location_long":homeSearch.location_long,
        });

      }


    this.getAllSalesProperty();

    if (isPlatformBrowser(this.platformId)) {
      this.alwarBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(environment.norteastLatLongFirst, environment.norteastLatLongSecond),
        new google.maps.LatLng(environment.southwestLatLongFirst, environment.southwestLatLongSecond)
      );

      this.options = {
        bounds: this.alwarBounds,
        componentRestrictions: { country: "IN" },
        strictBounds: environment.strictBounds,
      };
    }
  }

  resetSalesFilter(){
    this.offset=0;
    this.limit=12;
    this.notEmptyPost=true;
    this.notscrolly=true;
    this.soldProperties=[];
    this.getAllSalesProperty();
  }


  propertySearch = this.fb.group({
    looking_type: [''],
    location_lat: [],
    location_long: [],
    location: [],
    location_sublocality: [''],
  })


  handleAddressChange(event, type = '') {
    if (type == 'mannual' && event.target.value == '') {
      this.propertySearch.patchValue({
        location_lat: '',
        location_long: '',
        location: '',
        location_sublocality: '',
      });
    } else if (type == 'address') {
      this.propertySearch.patchValue({
        location_lat: event.geometry.location.lat(),
        location_long: event.geometry.location.lng(),
        location: event.formatted_address,
        location_sublocality: event.address_components[0].long_name,
      });
    }
  }


  searchProperty() {

    if(this.lookingType!=this.propertySearch.value.looking_type){

      this.router.navigateByUrl('sales-properties/'+this.propertySearch.value.looking_type);

    }else{
      this.resetSalesFilter();
    }


  }

  getAllSalesProperty(){
    
    if (this.notEmptyPost && this.notscrolly) {

      this.spinner.show();
 
      var lookingTypeValue='0';
      if(this.propertySearch.value.looking_type=='residential'){
        lookingTypeValue='1';
      }else if(this.propertySearch.value.looking_type=='commercial'){
        lookingTypeValue='2';
      }else if(this.propertySearch.value.looking_type=='agriculture'){
        lookingTypeValue='3';
      }else if(this.propertySearch.value.looking_type=='industrial'){
        lookingTypeValue='4';
      }
      this.listingLoader = true;
      this.service.post('/soldPropertyList',{"offset":this.offset,"limit":this.limit,"looking_type":lookingTypeValue,"location_lat":this.propertySearch.value.location_lat,"location_long":this.propertySearch.value.location_long}).subscribe((data)=>{
        if(data[0].error==0){

          Array.prototype.push.apply(this.soldProperties, data[0].result);
          this.offset += this.limit;
          
        }else{
          this.notEmptyPost = false;
        } 

        this.listingLoader = false;

        this.spinner.hide();

      });
      

    }

  }
}
